import './global.css';
import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Header from "./components/Layout/Header/Header";
import About from "./pages/public/about-company/About/About";
import FAQ from "./pages/public/about-company/FAQ/FAQ";
import Footer from "./components/Layout/Footer/Footer";
import Contact from "./pages/public/contact-us/Contact/Contact";
import BankingLicense from "./pages/public/Services/banking-license/BankingLicense";
import ContactForm from "./pages/public/contact-us/Contact Form/contactForm";
import OurServices from "./components/OurServices/OurServices";
import Newsletter from "./pages/public/NewsletterPage/NewsletterPage";
import Home from "./pages/public/home/Home";
import ScrollToTop from "./utils/ScrollToTop";
import Blog from "./pages/public/blog/Blog";
import PublicBlogDetail from "./pages/public/blog/BlogDetails/PublicBlogDetail";
import {AuthProvider} from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/public/login/login";
import DashboardHome from "./pages/dashboard/DashboardHome/DashboardHome";
import DashboardLayout from "./pages/dashboard/DashboardLayout";
import BlogsList from "./pages/dashboard/blogList/BlogsList";
import Profile from "./pages/dashboard/Profile/Profile";
import BlogDetail from "./pages/dashboard/blogDetail/BlogDetail";
import BlogForm from "./pages/dashboard/addEditBlog/BlogForm";
import WesternSaharaIBC from "./pages/public/Area/ibc/WesternSaharaIBC";
import MwaliIBC from "./pages/public/Area/ibc/MwaliIBC";
import AnjouanIBC from "./pages/public/Area/ibc/AnjouanIBC";
import WesternSaharaBankingLicense from "./pages/public/Services/banking-license/WesternSaharaBankingLicense";
import BankingLicenseMwali from "./pages/public/Services/banking-license/BankingLicenseMwali";
import BankingLicenseMalta from "./pages/public/Services/banking-license/BankingLicenseMalta";
import BankingLicenseCyprus from "./pages/public/Services/banking-license/BankingLicenseCyprus";
import BankingLicensePanama from "./pages/public/Services/banking-license/BankingLicensePanama";
import IsleManBankingFinTechLicense from "./pages/public/Services/banking-license/IsleManBankingFintechLicense";
import BankingLicenseSeychelles from "./pages/public/Services/banking-license/BankingLicenseSeychelles";
import BankingLicenseMauritius from "./pages/public/Services/banking-license/BankingLicenseMauritius";
import BankingLicenseSaintLucia from "./pages/public/Services/banking-license/BankingLicenseSaintLucia";
import WhyOffshoreAdvisory from "./pages/public/about-company/WhyOffshoreAdvisory/WhyOffshoreAdvisory";
import ClientTestimonials from "./pages/public/about-company/ClientTestimonials/ClientTestimonials";
import GamingLicenseServices from "./pages/public/Services/gaming-license/gaming-license-services";
import IGamingGamblingWesternSahara from "./pages/public/Services/iGaming-gambling/iGamingGamblingWesternSahara";
import GamingLicenseMwali from "./pages/public/Services/gaming-license/gaming-license-Mwali(Comoros)";
import GamingLicenseAnjouan from "./pages/public/Services/gaming-license/GamingLicenseAnjouan";
import GibraltariGamingLicense from "./pages/public/Services/iGaming-gambling/GibraltariGamingLicense";
import GamingiGamingLicenseMalta from "./pages/public/Services/iGaming-gambling/GamingiGamingLicenseMalta";
import GamingBettingLicenseCyprus from "./pages/public/Services/iGaming-gambling/GamingBettingLicenseCyprus";
import GamingLicensePanama from "./pages/public/Services/gaming-license/GamingLicensePanama";
import CuraçaoGamingLicense from "./pages/public/Services/iGaming-gambling/CuraçaoGamingLicense";
import GamingiGamingLicenseSeychelles from "./pages/public/Services/iGaming-gambling/GamingiGamingLicenseSeychelles";
import GamingBettingLicenseSaintLucia from "./pages/public/Services/iGaming-gambling/GamingBettingLicenseSaintLucia";
import BrokerageForexLicenses from "./pages/public/Services/forex-brokerage-license/BrokerageForexLicenses";
import ForexBrokerageLicenseWesternSahara
    from "./pages/public/Services/forex-brokerage-license/ForexBrokerageLicenseWesternSahara";
import ForexBrokerageLicenseMwali from "./pages/public/Services/forex-brokerage-license/ForexBrokerageLicenseMwali";
import BrokerageLicenseAnjouan from "./pages/public/Services/forex-brokerage-license/BrokerageLicenseAnjouan";
import BrokerageForexLicenseMalta from "./pages/public/Services/forex-brokerage-license/BrokerageForexLicenseMalta";
import ForexBrokerageLicenseCyprus from "./pages/public/Services/forex-brokerage-license/ForexBrokerageLicenseCyprus";
import SecuritiesDealerLicenseSeychelles
    from "./pages/public/Services/forex-brokerage-license/SecuritiesDealerLicenseSeychelles";
import ForexBrokerageVincentGrenadines from "./pages/public/Services/forex-brokerage-license/ForexBrokerageVincentGrenadines";
import FinancialLicenseAnjouan from "./pages/public/Services/FinancialLicenseAnjouan";
import GibraltarBankingFinTechLicense from "./pages/public/Services/GibraltarBankingFinTechLicense";
import CryptoVirtualAssetLicenses from "./pages/public/Services/crypto/CryptoVirtualAssetLicenses";
import CryptoLicenseWesternSahara from "./pages/public/Services/crypto/CryptoLicenseWesternSahara";
import CryptoLicenseMwali from "./pages/public/Services/crypto/CryptoLicenseMwali";
import CryptoLicenseAnjouan from "./pages/public/Services/crypto/CryptoLicenseAnjouan.js";
import GibraltarCryptoDLTLicense from "./pages/public/Services/crypto/GibraltarCryptoDLTLicense";
import CryptoBlockchainLicenseMalta from "./pages/public/Services/crypto/CryptoBlockchainLicenseMalta";
import CryptoBlockchainLicenseCyprus from "./pages/public/Services/crypto/CryptoBlockchainLicenseCyprus";
import CryptoLicensePanama from "./pages/public/Services/crypto/CryptoLicensePanama";
import CryptoDigitalAssetLicenseSeychelles from "./pages/public/Services/crypto/CryptoDigitalAssetLicenseSeychelles";
import CryptoVASPLicenseMauritius from "./pages/public/Services/crypto/CryptoVASPLicenseMauritius";
import TrustInsuranceLicenses from "./pages/public/Services/Trust & Insurance Licenses/TrustInsuranceLicenses";
import TrustInsuranceLicensesWesternSahara
    from "./pages/public/Services/Trust & Insurance Licenses/TrustInsuranceLicensesWesternSahara";
import TrustInsuranceLicensesMwali from "./pages/public/Services/Trust & Insurance Licenses/TrustInsuranceLicensesMwali";
import TrustInsuranceLicensesAnjouan from "./pages/public/Services/Trust & Insurance Licenses/TrustInsuranceLicensesAnjouan";
import GibraltarInsuranceReinsuranceLicense
    from "./pages/public/Services/Trust & Insurance Licenses/GibraltarInsuranceReinsuranceLicense";
import InsuranceReinsuranceLicenseMalta
    from "./pages/public/Services/Trust & Insurance Licenses/InsuranceReinsuranceLicenseMalta";
import InsuranceReinsuranceLicenseCyprus
    from "./pages/public/Services/Trust & Insurance Licenses/InsuranceReinsuranceLicenseCyprus";
import InsuranceCaptivesIsleMan from "./pages/public/Services/Trust & Insurance Licenses/InsuranceCaptivesIsleMan";
import InsuranceReinsuranceLicenseMauritius
    from "./pages/public/Services/Trust & Insurance Licenses/InsuranceReinsuranceLicenseMauritius";
import InsuranceReinsuranceLicenseSaintLucia
    from "./pages/public/Services/Trust & Insurance Licenses/InsuranceReinsuranceLicenseSaintLucia";
import InsuranceReinsuranceLicenseSeychelles
    from "./pages/public/Services/Trust & Insurance Licenses/InsuranceReinsuranceLicenseSeychelles";
import GibraltarFundsAssetManagementLicense from "./pages/public/Services/fund-asset/GibraltarFundsAssetManagementLicense";
import FundsAssetManagementIsleMan from "./pages/public/Services/fund-asset/FundsAssetManagementIsleMan";
import FundsAssetManagementLicenseMalta from "./pages/public/Services/fund-asset/FundsAssetManagementLicenseMalta";
import FundsAssetManagementLicensePanama from "./pages/public/Services/fund-asset/FundsAssetManagementLicensePanama";
import AssetManagementLicenseMwali from "./pages/public/Services/fund-asset/AssetManagementLicenseMwali";
import FundsAssetManagementLicenseMauritius from "./pages/public/Services/fund-asset/FundsAssetManagementLicenseMauritius";
import AssetManagementLicenseWesternSahara from "./pages/public/Services/fund-asset/AssetManagementLicenseWesternSahara";
import PaymentsFinTechLicenses from "./pages/public/Services/payments-finTech-licenses/PaymentsFinTechLicenses";
import PaymentServicesEMILicenseMalta from "./pages/public/Services/payments-finTech-licenses/PaymentServicesEMILicenseMalta";
import PaymentServicesEMILicenseCyprus
    from "./pages/public/Services/payments-finTech-licenses/PaymentServicesEMILicenseCyprus";
import PaymentsFinTechLicenseMauritius
    from "./pages/public/Services/payments-finTech-licenses/PaymentsFinTechLicenseMauritius";
import PaymentsFinTechLicenseSeychelles
    from "./pages/public/Services/payments-finTech-licenses/PaymentsFinTechLicenseSeychelles";
import FinTechPaymentsLicensePanama from "./pages/public/Services/payments-finTech-licenses/FinTechPaymentsLicensePanama";
import OffshoreCompanyFormation from "./pages/public/company-formation/OffshoreCompanyFormation";
import CyprusCompanyFormation from "./pages/public/company-formation/CyprusCompanyFormation";
import STLuciaCompanyFormation from "./pages/public/company-formation/St.LuciaCompanyFormation";
import UKCompanyFormation from "./pages/public/company-formation/UKCompanyFormation";
import IndonesiaCompanyFormation from "./pages/public/company-formation/IndonesiaCompanyFormation";
import PanamaCompanyFormation from "./pages/public/company-formation/PanamaCompanyFormation";
import MaltaCompanyFormation from "./pages/public/company-formation/MaltaCompanyFormation";
import MauritiusCompanyFormation from "./pages/public/company-formation/MauritiusCompanyFormation";
import IsleManCompanyFormation from "./pages/public/company-formation/IsleManCompanyFormation";
import StVincentCompanyFormation from "./pages/public/company-formation/StVincentCompanyFormation";
import UAECompanyFormation from "./pages/public/company-formation/UAECompanyFormation";
import SingaporeCompanyFormation from "./pages/public/company-formation/SingaporeCompanyFormation";
import CompanyFormationSeychelles from "./pages/public/company-formation/CompanyFormationSeychelles";
import CompanyFormationDominica from "./pages/public/company-formation/CompanyFormationDominica";
import ResidencyPassport from "./pages/public/residency-passport/ResidencyPassport";
import ResidencyInvestmentUAE from "./pages/public/residency-passport/ResidencyInvestmentUAE";
import GoldenVisaSpain from "./pages/public/residency-passport/GoldenVisaSpain";
import GoldenVisaItaly from "./pages/public/residency-passport/GoldenVisaItaly";
import ResidencyIndonesia from "./pages/public/residency-passport/ResidencyIndonesia";
import ResidencyInvestmentCyprus from "./pages/public/residency-passport/ResidencyInvestmentCyprus";
import ResidencyCitizenshipDominica from "./pages/public/residency-passport/ResidencyCitizenshipDominica";
import RealEstateInvestment from "./pages/public/real-estate/RealEstateInvestment";
import RealEstateInvestmentUAE from "./pages/public/real-estate/RealEstateInvestmentUAE";
import RealEstateInvestmentBaliIndonesia from "./pages/public/real-estate/RealEstateInvestmentBaliIndonesia";
import RealEstateInvestmentSpain from "./pages/public/real-estate/RealEstateInvestmentSpain";
import RealEstateInvestmentCyprus from "./pages/public/real-estate/RealEstateInvestmentCyprus";
import RealEstateInvestmentItaly from "./pages/public/real-estate/RealEstateInvestmentItaly";
import RealEstateInvestmentGreece from "./pages/public/real-estate/RealEstateInvestmentGreece";
import NonDomTaxRegime from "./pages/public/NonDomTaxRegime/NonDomTaxRegime";
import ItalyNonDomTaxRegime from "./pages/public/NonDomTaxRegime/ItalyNonDomTaxRegime";
import UKNonDomiciledTaxRegime from "./pages/public/NonDomTaxRegime/UKNonDomiciledTaxRegime";
import OffshoreBankAccountOpening from "./pages/public/offshore-bank-account-opening/OffshoreBankAccountOpening";
import FintechServices from "./pages/public/fintech-services/fintech-services";
import FinancialLicense from "./pages/public/financial-license/FinancialLicense";
import ReadyMade from "./pages/public/Area/ready-made/ReadyMade";
import AssetProtectionServices from "./pages/public/asset-protection-services/AssetProtectionServices";
import WesternSaharaJurisdiction from "./pages/public/Jurisdictions/WesternSaharaJurisdiction";
import ReadyMadeCompaniesWesternSahara from "./pages/public/Area/ready-made/ReadyMadeCompaniesWesternSahara";
import MwaliJurisdiction from "./pages/public/Jurisdictions/MwaliJurisdiction";
import AnjouanJurisdiction from "./pages/public/Jurisdictions/AnjouanJurisdiction";
import CompanyFormationGibraltar from "./pages/public/company-formation/CompanyFormationGibraltar";
import ResidencyInvestmentGibraltar from "./pages/public/residency-passport/ResidencyInvestmentGibraltar";
import GibraltarTrustsPrivateWealth from "./pages/public/Services/Trust & Insurance Licenses/GibraltarTrustsPrivateWealth";
import IsleManJurisdiction from "./pages/public/Jurisdictions/IsleManJurisdiction";
import ResidencyInvestmentIsleMan from "./pages/public/residency-passport/ResidencyInvestmentIsleMan";
import MaltaJurisdiction from "./pages/public/Jurisdictions/MaltaJurisdiction";
import CyprusJurisdiction from "./pages/public/Jurisdictions/CyprusJurisdiction";
import PanamaJurisdiction from "./pages/public/Jurisdictions/PanamaJurisdiction";
import TrustCompanyLicensePanama from "./pages/public/Services/Trust & Insurance Licenses/TrustCompanyLicensePanama";
import MaritimeShippingLicensesPanama from "./pages/public/Services/MaritimeShippingLicensesPanama";
import ResidencyCitizenshipInvestmentSaintLucia
    from "./pages/public/residency-passport/ResidencyCitizenshipInvestmentSaintLucia";
import SeychellesJurisdiction from "./pages/public/Jurisdictions/SeychellesJurisdiction";
import MauritiusJurisdiction from "./pages/public/Jurisdictions/MauritiusJurisdiction";
import CuraçaoJurisdiction from "./pages/public/Jurisdictions/CuraçaoJurisdiction";
import StVincentJurisdiction from "./pages/public/Jurisdictions/StVincentJurisdiction";
import UnitedArabEmiratesJurisdiction from "./pages/public/Jurisdictions/UnitedArabEmiratesJurisdiction";
import UnitedKingdomJurisdiction from "./pages/public/Jurisdictions/UnitedKingdomJurisdiction";
import SingaporeJurisdiction from "./pages/public/Jurisdictions/SingaporeJurisdiction";
import IndonesiaJurisdiction from "./pages/public/Jurisdictions/IndonesiaJurisdiction";
import GreeceJurisdiction from "./pages/public/Jurisdictions/GreeceJurisdiction";
import SpainJurisdiction from "./pages/public/Jurisdictions/SpainJurisdiction";
import ItalyJurisdiction from "./pages/public/Jurisdictions/ItalyJurisdiction";
import DominicaJurisdiction from "./pages/public/Jurisdictions/DominicaJurisdiction";
import CompanyFormationAndorra from "./pages/public/company-formation/CompanyFormationAndorra";
import AndorraResidencyGoldenVisa from "./pages/public/residency-passport/AndorraResidencyGoldenVisa";
import AndorraCarLicense from "./pages/public/Services/AndorraCarLicense";
import GamingLicenseTuvalu from "./pages/public/Services/gaming-license/GamingLicenseTuvalu";
import GamingLicenseGhana from "./pages/public/Services/gaming-license/GamingLicenseGhana";
import NetherlandsCompanySale from "./pages/public/Services/company-sale/NetherlandsCompanySale";
import CanadianMSBLicense from "./pages/public/Services/gaming-license/CanadianMSBLicense";

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Main />
            </BrowserRouter>
        </AuthProvider>
    );
}
function Main() {
    const { pathname } = useLocation();

    // Normalize to avoid trailing slash edge cases
    const cleanPath = pathname.replace(/\/+$/, '') || '/';

    // Hide on all blog routes
    const isBlog = cleanPath.startsWith('/blog') || cleanPath.includes('blog');

    // DashboardHome routes
    const isDashboard = cleanPath.startsWith('/dashboard');

    // Login route
    const isLogin = cleanPath.startsWith('/login');
    
    useEffect(() => {
        const shouldHideTawk = isDashboard;

        // CSS fallback: hide the injected iframe/container even if API isn't ready yet
        document.body.classList.toggle('hide-tawk', shouldHideTawk);

        const toggleViaApi = () => {
            try {
                const api = window.Tawk_API;
                if (!api) return false;

                if (shouldHideTawk && typeof api.hideWidget === 'function') {
                    api.hideWidget();
                    return true;
                }

                if (!shouldHideTawk && typeof api.showWidget === 'function') {
                    api.showWidget();
                    return true;
                }
            } catch (e) {
                // ignore
            }
            return false;
        };

        // Try immediately (works when Tawk already loaded)
        if (toggleViaApi()) return;

        // Ensure we can catch initial widget load
        window.Tawk_API = window.Tawk_API || {};
        const prevOnLoad = window.Tawk_API.onLoad;
        window.Tawk_API.onLoad = function () {
            if (typeof prevOnLoad === 'function') prevOnLoad();
            toggleViaApi();
        };

        // Also poll briefly because script loads async
        const startedAt = Date.now();
        const intervalId = window.setInterval(() => {
            const ok = toggleViaApi();
            const timedOut = Date.now() - startedAt > 5000;
            if (ok || timedOut) window.clearInterval(intervalId);
        }, 250);

        return () => window.clearInterval(intervalId);
    }, [isDashboard]);

   const hideComponentsPages = [
        '/',
        '/about',
        '/faq',
        '/why-offshore-advisory',
        '/client-testimonials',
        '/contact',
        '/newsletter'
    ];

    const isContactPage = cleanPath === '/contact';
    const shouldHideComponents = hideComponentsPages.includes(cleanPath);
    return (
        <>
            <ScrollToTop/>

            {/* ✅ Hide header on login page */}
            {!isLogin && !isDashboard && <Header />}

            <Routes>

                <Route path="/" element={
                    <>
                        <Home/>

                    </>
                } />

                {/* newsletter */}
                <Route path="/newsletter" element={<Newsletter/>} />

                {/* ABOUT THE COMPANY */}
                <Route path="/about" element={<About />} />
                <Route path="/why-offshore-advisory" element={<WhyOffshoreAdvisory/>} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/client-testimonials" element={<ClientTestimonials />} />


                {/* GAMING LICENSES */}
                <Route path='/gaming-license-services' element={<GamingLicenseServices/>} />
                <Route path="/igaming-gambling-western-sahara" element={<IGamingGamblingWesternSahara/>} />
                <Route path='/gaming-license-mwali' element={<GamingLicenseMwali/>} />
                <Route path='/gaming-license-anjouan' element={<GamingLicenseAnjouan/>} />
                <Route path="/gibraltar-igaming-license" element={<GibraltariGamingLicense/>} />
                <Route path="/gaming-igaming-license-malta" element={<GamingiGamingLicenseMalta/>} />
                <Route path="/gaming-betting-license–cyprus" element={<GamingBettingLicenseCyprus/>} />
                <Route path="/gaming-license–panama" element={<GamingLicensePanama/>} />
                <Route path="/curaçao-gaming-license" element={<CuraçaoGamingLicense/>} />
                <Route path="/gaming-igaming-license–seychelles" element={<GamingiGamingLicenseSeychelles/>} />
                <Route path="/gaming-betting-license–saint-lucia" element={<GamingBettingLicenseSaintLucia/>} />
                <Route path="/gaming-license–tuvalu" element={<GamingLicenseTuvalu/>} />
                <Route path="/gaming-license–ghana" element={<GamingLicenseGhana/>} />

                {/* forex and brokerage license */}
                <Route path="/brokerage-forex-licenses" element={<BrokerageForexLicenses/>} />
                <Route path="/forex-brokerage-license-western-sahara" element={<ForexBrokerageLicenseWesternSahara/>} />
                <Route path="/forex-brokerage-license-mwali" element={<ForexBrokerageLicenseMwali/>} />
                <Route path="/brokerage-license-anjouan" element={<BrokerageLicenseAnjouan/>} />
                <Route path="/brokerage-forex-license-malta" element={<BrokerageForexLicenseMalta/>} />
                <Route path="/forex-brokerage-license-cyprus" element={<ForexBrokerageLicenseCyprus/>} />
                <Route path="/securities-dealer-license-seychelles" element={<SecuritiesDealerLicenseSeychelles/>} />
                <Route path="/forex-brokerage-St-vincent-grenadines" element={<ForexBrokerageVincentGrenadines/>} />


                {/* banking license */}
                <Route path="/banking-license" element={<BankingLicense/>} />
                <Route path="/banking-license-malta" element={<BankingLicenseMalta/>} />
                <Route path="/banking-license-cyprus" element={<BankingLicenseCyprus/>} />
                <Route path="/banking-license-panama" element={<BankingLicensePanama/>} />
                <Route path="/banking-license-seychelles" element={<BankingLicenseSeychelles/>} />
                <Route path="/banking-license-mauritius" element={<BankingLicenseMauritius/>} />
                <Route path="/banking-license-saint-lucia" element={<BankingLicenseSaintLucia/>} />
                <Route path="/western-sahara-banking-license" element={<WesternSaharaBankingLicense />} />
                <Route path="/banking-license-mwali" element={<BankingLicenseMwali/>} />


                <Route path="/financial-license-anjouan" element={<FinancialLicenseAnjouan />} />
                <Route path="/gibralta-banking-finTech-license" element={<GibraltarBankingFinTechLicense />} />
                <Route path="/isle-man-banking-fintech-license" element={<IsleManBankingFinTechLicense/>} />
                <Route path="/canadian-msb-license" element={<CanadianMSBLicense/>} />


                {/* crypto & blockchain */}
                <Route path="/netherlands-company-sale" element={<NetherlandsCompanySale/>} />

                {/* crypto & blockchain */}
                <Route path="/crypto-virtual-asset-licenses" element={<CryptoVirtualAssetLicenses/>} />
                <Route path="/crypto-license-western-sahara" element={<CryptoLicenseWesternSahara/>} />
                <Route path="/crypto-license-mwali" element={<CryptoLicenseMwali/>} />
                <Route path="/crypto-license-anjouan" element={<CryptoLicenseAnjouan/>} />
                <Route path="/gibraltar-crypto-dlt-license" element={<GibraltarCryptoDLTLicense/>} />
                <Route path="/crypto-blockchain-license-malta" element={<CryptoBlockchainLicenseMalta/>} />
                <Route path="/crypto-blockchain-license-cyprus" element={<CryptoBlockchainLicenseCyprus/>} />
                <Route path="/crypto-license-panama" element={<CryptoLicensePanama/>} />
                <Route path="/crypto-digital-asset-license-seychelles" element={<CryptoDigitalAssetLicenseSeychelles/>} />
                <Route path="/Crypto-vasp-license-mauritius" element={<CryptoVASPLicenseMauritius/>} />


                {/* Trust Insurance Licenses */}
                <Route path="/trust-insurance-licenses" element={<TrustInsuranceLicenses/>} />
                <Route path="/trust-insurance-licenses-western-sahara" element={<TrustInsuranceLicensesWesternSahara/>} />
                <Route path="/trust-insurance-licenses-mwali" element={<TrustInsuranceLicensesMwali/>} />
                <Route path="/trust-insurance-licenses-anjouan" element={<TrustInsuranceLicensesAnjouan/>} />
                <Route path="/gibraltar-insurance-reinsurance-license" element={<GibraltarInsuranceReinsuranceLicense/>} />
                <Route path="/insurance-reinsurance-license-malta" element={<InsuranceReinsuranceLicenseMalta/>} />
                <Route path="/insurance-reinsurance-cyprus" element={<InsuranceReinsuranceLicenseCyprus/>} />
                <Route path="/insurance-reinsurance-license-panama" element={<CryptoBlockchainLicenseCyprus/>} />
                <Route path="/insurance-captives-isle-man" element={<InsuranceCaptivesIsleMan/>} />
                <Route path="/insurance-reinsurance-license-mauritius" element={<InsuranceReinsuranceLicenseMauritius/>} />
                <Route path="/insurance-reinsurance-license-saint-lucia" element={<InsuranceReinsuranceLicenseSaintLucia/>} />
                <Route path="/insurance-reinsurance-license-seychelles" element={<InsuranceReinsuranceLicenseSeychelles/>} />
                <Route path="/gibraltar-funds-asset-management-license" element={<GibraltarFundsAssetManagementLicense/>} />
                <Route path="/gibraltar-trusts-private-wealth" element={<GibraltarTrustsPrivateWealth/>} />
                <Route path="/trust-company-license-panama" element={<TrustCompanyLicensePanama/>} />

                <Route path="/maritime-shipping-license-panama" element={<MaritimeShippingLicensesPanama/>} />

                <Route path='/andorra-car-license' element={<AndorraCarLicense/>} />

                {/* fund & asset */}
                <Route path="/funds-asset-management-isle-man" element={<FundsAssetManagementIsleMan/>} />
                <Route path="/funds-asset-management-license-malta" element={<FundsAssetManagementLicenseMalta/>} />
                <Route path="/funds-asset-management-license-cyprus" element={<CryptoBlockchainLicenseCyprus/>} />
                <Route path="/funds-asset-management-license-panama" element={<FundsAssetManagementLicensePanama/>} />
                <Route path="/asset-management-license-mwali" element={<AssetManagementLicenseMwali/>} />
                <Route path="/funds-asset-management-license-mauritius" element={<FundsAssetManagementLicenseMauritius/>} />
                <Route path="/asset-management-license-western-sahara" element={<AssetManagementLicenseWesternSahara/>} />

                {/* payment and fintech */}
                <Route path="/payments-fintech-licenses" element={<PaymentsFinTechLicenses/>} />
                <Route path="/gibraltar-banking-finTech-license" element={<GibraltarBankingFinTechLicense/>} />
                <Route path="/payment-services-EMI-license-malta" element={<PaymentServicesEMILicenseMalta/>} />
                <Route path="/payment-services-EMI-license-cyrus" element={<PaymentServicesEMILicenseCyprus/>} />
                <Route path="/payments-fintech-license-mauritius" element={<PaymentsFinTechLicenseMauritius/>} />
                <Route path="/payments-fintech-license-seychelles" element={<PaymentsFinTechLicenseSeychelles/>} />
                <Route path="/payments-fintech-license-panama" element={<FinTechPaymentsLicensePanama/>} />

                {/* COMPANY FORMATION */}
                <Route path="/offshore-company-formation" element={<OffshoreCompanyFormation/>} />
                <Route path="/western-sahara-ibc" element={<WesternSaharaIBC/>} />
                <Route path="/mwali-ibc" element={<MwaliIBC/>} />
                <Route path="/anjouan-ibc" element={<AnjouanIBC/>} />
                <Route path="/cyprus-company-formation" element={<CyprusCompanyFormation/>} />
                <Route path="/st-lucia-company-formation" element={<STLuciaCompanyFormation/>} />
                <Route path="/uk-company-formation" element={<UKCompanyFormation/>} />
                <Route path="/indonesia-company-formation" element={<IndonesiaCompanyFormation/>} />
                <Route path="/panama-company-formation" element={<PanamaCompanyFormation/>} />
                <Route path="/malta-company-formation" element={<MaltaCompanyFormation/>} />
                <Route path="/mauritius-company-formation" element={<MauritiusCompanyFormation/>} />
                <Route path="/isle-man-company-formation" element={<IsleManCompanyFormation/>} />
                <Route path="/st-vincent-company-formation" element={<StVincentCompanyFormation/>} />
                <Route path="/uae--company-formation" element={<UAECompanyFormation/>} />
                <Route path="/singapore-company-formation" element={<SingaporeCompanyFormation/>} />
                <Route path="/seychelles-company-formation" element={<CompanyFormationSeychelles/>} />
                <Route path="/dominica-company-formation" element={<CompanyFormationDominica/>} />
                <Route path="/company-formation-gibraltar" element={<CompanyFormationGibraltar/>} />
                <Route path="/company-formation-andorra" element={<CompanyFormationAndorra/>} />

                {/* residency and passport */}
                <Route path='/residency-passport' element={<ResidencyPassport/>} />
                <Route path='/residency-investment-uaet' element={<ResidencyInvestmentUAE/>} />
                <Route path='/golden-visa-spain' element={<GoldenVisaSpain/>} />
                <Route path='/golden-visa-italy' element={<GoldenVisaItaly/>} />
                <Route path='/residency-indonesia' element={<ResidencyIndonesia/>} />
                <Route path='/residency-investment-cyprus' element={<ResidencyInvestmentCyprus/>} />
                <Route path='/residency-citizenship-dominica' element={<ResidencyCitizenshipDominica/>} />
                <Route path='/residency-investment-gibraltar' element={<ResidencyInvestmentGibraltar/>} />
                <Route path='/residency-investment-isle-man' element={<ResidencyInvestmentIsleMan/>} />
                <Route path='/residency-citizenship-investment-saint-lucia' element={<ResidencyCitizenshipInvestmentSaintLucia/>} />
                <Route path='/andorra-residency-golden-visa' element={<AndorraResidencyGoldenVisa/>} />



                {/* real estate  */}
                <Route path="/real-estate-investment" element={<RealEstateInvestment />} />
                <Route path="/real-estate-investment-uae" element={<RealEstateInvestmentUAE />} />
                <Route path="/real-estate-investment-bali-indonesia" element={<RealEstateInvestmentBaliIndonesia />} />
                <Route path="/real-estate-investment-spain" element={<RealEstateInvestmentSpain />} />
                <Route path="/real-estate-investment-cyprus" element={<RealEstateInvestmentCyprus />} />
                <Route path="/real-estate-investment-italy" element={<RealEstateInvestmentItaly />} />
                <Route path="/real-estate-investment-greece" element={<RealEstateInvestmentGreece />} />

                {/* financial & advisory  */}
                <Route path="/offshore-bank-account-opening" element={<OffshoreBankAccountOpening />} />
                <Route path="/fintech-services" element={<FintechServices />} />
                <Route path="/financial-license" element={<FinancialLicense />} />
                {/* ready made */}
                <Route path="/ready-made" element={<ReadyMade />} />
                <Route path="/ready-made-companies-corporate-bank-accounts" element={<ReadyMade />} />
                <Route path="/ready-made-companies-western-sahara" element={<ReadyMadeCompaniesWesternSahara />} />
                <Route path="/assets-protection" element={<AssetProtectionServices />} />

                {/* non dom  */}
                <Route path="/non-dom-tax-regime" element={<NonDomTaxRegime />} />
                <Route path="/uk-non-domiciled-tax-regime" element={<UKNonDomiciledTaxRegime />} />
                <Route path="/ital-non-dom-tax-regime" element={<ItalyNonDomTaxRegime />} />

                {/* jurisdictions */}
                <Route path="/western-sahara-jurisdiction" element={<WesternSaharaJurisdiction />} />
                <Route path="/mwali-jurisdiction" element={<MwaliJurisdiction />} />
                <Route path="/anjouan-jurisdiction" element={<AnjouanJurisdiction />} />
                <Route path="/isle-man-jurisdiction" element={<IsleManJurisdiction />} />
                <Route path="/malta-jurisdiction" element={<MaltaJurisdiction />} />
                <Route path="/cyprus-jurisdiction" element={<CyprusJurisdiction />} />
                <Route path="/panama-jurisdiction" element={<PanamaJurisdiction />} />
                <Route path="/seychelles-jurisdiction" element={<SeychellesJurisdiction />} />
                <Route path="/mauritius-jurisdiction" element={<MauritiusJurisdiction />} />
                <Route path="/curaçao-jurisdiction" element={<CuraçaoJurisdiction />} />
                <Route path="/st-vincent-jurisdiction" element={<StVincentJurisdiction />} />
                <Route path="/united-arab-emirates-jurisdiction" element={<UnitedArabEmiratesJurisdiction />} />
                <Route path="/united-kingdom-jurisdiction" element={<UnitedKingdomJurisdiction />} />
                <Route path="/singapore-jurisdiction" element={<SingaporeJurisdiction />} />
                <Route path="/indonesia-jurisdiction" element={<IndonesiaJurisdiction />} />
                <Route path="/greece-jurisdiction" element={<GreeceJurisdiction />} />
                <Route path="/spain-jurisdiction" element={<SpainJurisdiction />} />
                <Route path="/italy-jurisdiction" element={<ItalyJurisdiction />} />
                <Route path="/dominica-jurisdiction" element={<DominicaJurisdiction />} />

                {/* CONTACT */}
                <Route path="/contact" element={<Contact />} />

                {/* BLOG */}
                <Route path="/blogs" element={<Blog/>} />
                <Route path="/blogs/:slug" element={<PublicBlogDetail/>} />

                {/* DASHBOARD ROUTES element={<DashboardLayout />*/}
                <Route
                    path="/dashboard"
                    element={
                        <ProtectedRoute>
                            <DashboardLayout />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<DashboardHome />} />
                    <Route path="profile" element={<Profile />} />
                    <Route path='blog-list' element={<BlogsList/>} />
                    <Route path="blog/:id" element={<BlogDetail />} />
                    <Route path="add-blog" element={<BlogForm/>} />
                    <Route path="edit-blog/:id" element={<BlogForm/>} />
                </Route>

                {/* login */}
                <Route path='/login' element={<Login/>}/>

            </Routes>

            {/* Условный рендеринг компонентов */}
            {!isDashboard && !isLogin && (
                <>
                    {/* Страница контактов - особый порядок */}


                    {/* Остальные страницы - обычный порядок, кроме указанных и блогов */}
                    {!isContactPage && !shouldHideComponents && !isBlog && (
                        <>
                            <OurServices />
                            <ContactForm />
                        </>
                    )}

                    {/* Футер показываем всегда */}
                    <Footer />
                </>
            )}
        </>
    );
}

export default App;